import MenuItem from "src/components/Menu/Item";
import ItemText from "src/components/Menu/ItemText";
import { Flex, Box } from "@chakra-ui/react";
import { ReactComponent as TickIcon } from "./icon-done.svg";

export default function LabeledCameraList({
  cameraList,
  handleCameraChange,
  selectedCameraId
}) {
  return cameraList.map((camera, i) => (
    <MenuItem
      key={camera.label || camera.name}
      onClick={() =>
        handleCameraChange(camera.deviceId || camera.cameraId || camera.groupId)
      }
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        maxWidth="203px"
      >
        <ItemText
          mr="0px !important"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          maxWidth="150px"
        >
          {camera.label || camera.name || `Camera ${i + 1}`}
        </ItemText>
        <Box mx="16px" minWidth="20px">
          {(selectedCameraId === camera.deviceId ||
            selectedCameraId === camera.cameraId) && (
            <Box
              sx={{
                svg: { fill: "primary" }
              }}
            >
              <TickIcon />
            </Box>
          )}
        </Box>
      </Flex>
    </MenuItem>
  ));
}
